import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Reactions, ReactionsComponent, Threads, TimelineItem, TimelineItemType } from "@teammood/timeline";
import { MatTabsModule } from '@angular/material/tabs';
import { ThreadsComponent } from "../../../threads/threads.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserInfos } from "../../../../shared/ui/username-icon/user-infos.type";
import { ReviewBadgeComponent } from "../../review-badge/review-badge.component";
import {
    ClosedQuestionResultBarChartComponent
} from "./closed-question-result-bar-chart/closed-result-bar-chart.component";
import { PollResultService } from "../poll-result.service";
import { PollResultCommentsComponent } from "../poll-result-comments/poll-result-comments.component";
import { ClosedPollResultTimelineItem } from "../poll-result.type";
import { ClosedRecurrencePollResults } from "app/frontend/lib/polls/create-poll/create-poll.type";
import { CommonModule } from "@angular/common";
import { RecurringPollResultTrendsComponent } from "../recurring/recurring-poll-result-trends.component";
import { ManagerPanelComponent } from "../../manager-panel/manager-panel.component";

@Component({
    selector: "tm-closed-poll-result-card",
    templateUrl: "./closed-poll-result.component.html",
    styleUrls: ['./../poll-result.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatTabsModule,
        ClosedQuestionResultBarChartComponent,
        ReactionsComponent,
        ThreadsComponent,
        TranslateModule,
        ReviewBadgeComponent,
        PollResultCommentsComponent,
        RecurringPollResultTrendsComponent,
        ManagerPanelComponent
    ]
})
export class ClosedPollResultCardComponent implements OnInit{
    
    protected tabIndexToShow: number = 0;
    protected showThreads: boolean = true;
    protected resultsTabLabel: string;
    protected trendsTabLabel: string;
    protected participationCount: number;
    protected allResults: ClosedRecurrencePollResults;
    protected dates: string[];

    @ViewChild('threadsComponent')
    private threadsComponent: ThreadsComponent;

    @Input() 
    pollResult: ClosedPollResultTimelineItem;

    @Input() teamId: string;

    @Input() userInfos: UserInfos;

    @Input() isOdd: boolean;
    
    constructor(
        private translateService: TranslateService,
        private pollResultService: PollResultService
    ) {
        this.resultsTabLabel = this.translateService.instant('poll_results.results')
        this.trendsTabLabel = this.translateService.instant('poll_results.trends')
    }
    ngOnInit() {
        this.participationCount = this.pollResultService.getParticipationCount(this.pollResult.results.values);
    }

    onTabChanged(event){
        this.tabIndexToShow = event.index;
    }

    protected toggleThreads() {
        this.showThreads = !this.showThreads;
    }
    protected discuss() {
        if (this.threadsComponent) {
            this.threadsComponent.discuss = true;
        }
    }

    protected onReacted(timelineItem: {id: string, itemType: TimelineItemType} & Reactions): void {
        if (timelineItem.itemType == "closedQuestionResultItem"){
            this.pollResult = timelineItem as ClosedPollResultTimelineItem;
        }
    }

    protected onThreadsUpdated(timelineItem: TimelineItem & Threads): void {
        if (timelineItem.itemType == "closedQuestionResultItem"){
            this.pollResult = timelineItem as ClosedPollResultTimelineItem;
        }
    }
}